import type { ReactNode } from 'react'

// The design's uppercase tag: outcome and environment markers rendered as small
// letterspaced pills. The casing is a style, not content — children keep their
// natural casing so text queries and screen readers see "Delivered", not a
// shouted "DELIVERED".

const TONES = {
  success: {
    background: 'var(--color-background-system-success)',
    color: 'var(--color-text-success)',
  },
  danger: {
    background: 'var(--color-background-system-danger)',
    color: 'var(--color-text-danger)',
  },
  info: {
    background: 'var(--color-background-system-information)',
    color: 'var(--color-text-information)',
  },
  neutral: {
    background: 'var(--color-background-neutral-primary)',
    color: 'var(--curri-text-secondary)',
  },
} satisfies Record<string, { background: string; color: string }>

export const Pill = ({
  children,
  tone,
}: {
  children: ReactNode
  tone: keyof typeof TONES
}) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      height: 22,
      padding: '0 9px',
      borderRadius: 6,
      fontSize: 10.5,
      fontWeight: 600,
      letterSpacing: '0.07em',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
      ...TONES[tone],
    }}
  >
    {children}
  </span>
)
